import { render, staticRenderFns } from "./Uti.vue?vue&type=template&id=0236097a&"
import script from "./Uti.vue?vue&type=script&lang=js&"
export * from "./Uti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports